import { Close } from '@mui/icons-material'
import { Box, DialogTitle, IconButton, Typography } from '@mui/material'
import { isNil } from 'lodash'

interface DialogTitleWithIconCloseProps {
  disabled?: boolean
  label?: string | JSX.Element
  paddingBottom?: number | string
  handleClose: React.MouseEventHandler<HTMLButtonElement>
}

/**
 * DialogTitle with added close icon
 * @category Common components
 * @subcategory MUI extended
 * @component
 * @returns {JSX.Element}
 * @property {boolean} disabled If close icon should be disabled
 * @property {function} handleClose Passed to on close icon onClick event
 * @property {(string|JSX.Element)} label Dialog title label
 */
export const DialogTitleWithIconClose = ({ handleClose, label, disabled, paddingBottom }: DialogTitleWithIconCloseProps): JSX.Element => {
  return (
    <Box sx={{ position: 'relative', paddingTop: '32px', paddingX: '48px' }}>
      <IconButton
        sx={{ position: 'absolute', top: 0.5, right: 0.5, color: 'primary.main' }}
        onClick={handleClose}
        disabled={disabled}
      >
        <Close sx={{ fontSize: '44px' }} />
      </IconButton>

      {!isNil(label) && (
        <DialogTitle>
          <Typography
            sx={{
              textAlign: 'center',
              color: 'primary.main',
              fontSize: '24px',
              lineHeight: '28px',
              fontWeight: 700
            }}
          >
            {label}
          </Typography>
        </DialogTitle>
      )}
    </Box>
  )
}
